<template>
  <div class="button-group-container">
    {{  }}
    <!--<PromoModal v-if="$store.state.gameSettings.promotions.length > 0"-->
        <!--:slug=$store.state.gameSettings.promotions[0].slug-->
        <!--:title=$store.state.gameSettings.promotions[0].name-->
        <!--:message=$store.state.gameSettings.promotions[0].description-->
    <!--/>-->
    <router-link
      v-for="(btn, index) in buttons"
      :key="index"
      :to="getRouteWithQuery(btn.route)"
      class="button__primary button-item"
      :class="{ active: isActiveRoute(btn.route) }"
    >
      {{ getTranslatedText(btn.label) }}
    </router-link>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";
import PromoModal from "@/components/common/promo/promo-modal.vue";
export default {
  name: "HomeFooterButton",
  mixins: [languageMixins],
  data() {
    return {
      buttons: [
        { label: "how to play", route: "/how-to-play" },
        { label: "markets", route: "/markets" },
        { label: "T's & C's", route: "/terms-and-conditions" },
      ],
    };
  },
  methods: {
    getRouteWithQuery(route) {
      const query = this.$route.query;
      return { path: route, query };
    },

    isActiveRoute(route) {
      return this.$route.path.includes(route);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-group-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  width: 100%;
  max-width: 600px;
  margin: 10px auto;

  @media (max-width: 768px) {
    gap: 10px;
  }

  .button__primary {
    flex: 1;
    min-width: 110px;
    max-width: 180px;
    text-align: center;
    background-color: #0000ff;
    color: white;
    border: none;
    border-radius: 30px;
    padding: 10px 15px;
    font-size: 14px;
    font-weight: bold;
    text-decoration: none;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #0000cc;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 5px #0000ff;
    }

    &.active {
      color: #000000;
      background-color: #ede5e5;
    }

    @media (max-width: 768px) {
      padding: 8px 12px;
      font-size: 12px;
    }
  }
}
</style>
